<template>
  <div class="home-service">
    <nav-header :activeIndex="7" />
    <main class="home-service-content">
      <router-view></router-view>
      <div class="login-wrapper">
        <div>
          <el-steps :active="registerActive" align-center>
            <el-step title="步骤1" description="请扫码注册"></el-step>
            <el-step title="步骤2" description="请填写基本信息"></el-step>
          </el-steps>
        </div>
        <div class="register-flex">
          <div class="register-flex-wechat" v-if="showOne">
            <el-button size="small" type="primary" class="register-flex-wechat-button" v-show="showCode" @click="registerCode">微信注册</el-button>
            <div id="login-container" v-show="!showCode" class="login-qrcode" ref="loginContainer"></div>
          </div>
          <div class="register-flex-two" v-if="!showOne">
            <el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-width="100px">
              <el-form-item label="用户名:" prop="userName">
                <el-input v-model="registerForm.userName" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="手机号:" prop="userPhone">
                <el-input v-model="registerForm.userPhone" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="邮箱:" prop="userEmail">
                <el-input v-model="registerForm.userEmail" placeholder="请输入邮箱"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="registerFun('registerForm')">注册</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import NavHeader from '@/common-components/nav-header'
  import api from './api'
  import { Message } from 'element-ui/lib'
  export default {
    name: 'register',
    components: {
      NavHeader
    },
    data () {
      return {
        registerForm: {
          userName: '',
          userPhone: '',
          userEmail: ''
        },
        registerActive: 1,
        showOne: true,
        showCode: true,
        registerRules: {
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
          ],
          userPhone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/, message: '电话号码格式不正确', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      async registerCode () {
        let res = await api.getQRCode()
        if (res) {
          let url = ''
          if (process.env.NODE_ENV === 'production') {
            url = 'lawhelpads.cn'
          } else {
            url = 'devmk.alphalawyer.cn'
          }
          const data = res.data
          const wx = new WxLogin({ // eslint-disable-line
            id: 'login-container',
            appid: data.data.appId,
            scope: data.data.scope,
            redirect_uri: encodeURIComponent(`https://wealth.alphalawyer.cn/wechatlogin/${url}/#/register/callback`),
            state: data.data.state,
            style: 'black',
            href: 'https://devev.alphalawyer.cn/wechat/ev.css'
          })
          this.showCode = !this.showCode
          document.querySelector('#login-container iframe').setAttribute('sandbox', 'allow-same-origin allow-top-navigation allow-forms allow-scripts')
        }
      },
      registerFun (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let obj = {
              name: this.registerForm.userName,
              phone: this.registerForm.userPhone,
              unionId: localStorage.getItem('unionId'),
              email: this.registerForm.userEmail
            }
            api.getRegister(obj).then(res => {
              if (res.data.isSuccess) {
                this.$alert('注册成功', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.push({path: `/home`})
                  }
                })
              } else {
                Message.error(res.data.resultMsg)
              }
            })
          }
        })
      }
    },
    created () {
      if (localStorage.getItem('unionId')) {
        this.registerActive = 2
        this.showOne = false
      } else {
        this.registerActive = 1
        this.showOne = true
      }
    }
  }
</script>

<style lang="stylus">
  .register-flex {
    min-height: 4rem;
    &-wechat {
      position: absolute;
      left: 22%;
      &-button {
        margin-top: 1.5rem;
      }
      &-qrcode {
        width: 1.88rem;
        height: 1.88rem;
        background-color: red;
        margin-top: 1rem;
      }
    }
    &-two {
      padding-top: .4rem;
      width: 4rem;
      margin: 0 auto;
    }
  }
  .home-service {
    &-content {
      margin-top .72rem
    }
  }
  .login-wrapper {
    background #464c63 url("../../assets/login-background.jpg") no-repeat 50%
    position: relative;
    margin: 0;
    padding: 0;
    height: 100%;
    text-align: center;
    min-height: 471px;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue